export const FAST_API_URL = "https://fastapi.dev.torsunov.pro";
export const RAG_API_URL = "https://rag.dev.myrevive.app";
export const AVATAR_API_URL = "https://api.heygen.com";
